/* eslint-disable max-len */
import { Directory } from './constants';

export const listDirectoryRequest = (data, callback) => ({ type: Directory.listDirectoryRequest, data, callback });
export const listDirectorySuccess = (data) => ({ type: Directory.listDirectorySuccess, data });
export const listDirectoryError = () => ({ type: Directory.listDirectoryError });
